import t from "./generateUtilityClasses.mjs";
import l from "./generateUtilityClass.mjs";
function o(e) {
  return l("MuiSelect", e);
}
const i = t("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), a = i;
export {
  a as default,
  o as getSelectUtilityClasses
};
//# sourceMappingURL=selectClasses.mjs.map
